import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * Defines the upgrade path for version 7 of indexed DB.
 */
export class DatabaseUpgradeV7 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 7;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			FileCaptureConfiguration: "Id, UserName, CrownId"
		});
	}
}